import React from 'react';

const SupportButton = ({ onClick }) => {
  return (
    <button
      type="button"
      className="flex items-center space-x-2 rounded border border-[#9C27B0] py-1 px-3 text-base font-semibold text-[#9C27B0] transition-colors duration-200 hover:bg-[rgba(156,39,176,0.2)]"
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="tabler-icon tabler-icon-message-question"
      >
        <path d="M8 9h8"></path>
        <path d="M8 13h6"></path>
        <path d="M14 18h-1l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"></path>
        <path d="M19 22v.01"></path>
        <path d="M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"></path>
      </svg>

      <span>Contact Support</span>
    </button>
  );
};

export default SupportButton;
